import FitParser from 'fit-file-parser';

import type {ParseOutput} from './parseFile';

function getTimestamp(timestamp: string | undefined) {
    let parsedTimestamp = 0;
    try {
        parsedTimestamp = new Date(timestamp || '').getTime() / 1000;
    } catch (e) {
        // no-op
    }
    return parsedTimestamp;
}

export default async function loadFit(fileContents: ArrayBuffer): Promise<ParseOutput> {
    const fitParser = new FitParser({mode: 'list', force: true});

    return new Promise((resolve) => {
        fitParser.parse(fileContents, (error: any, data: Fit) => {
            if (error || !data || !data.records) {
                resolve(['Unable to parse file', undefined]);
                return;
            }

            const geometry = [];

            for (let i = 0; i < data.records.length; i++) {
                const lng = data.records[i].position_long;
                const lat = data.records[i].position_lat;
                if (!lng || !lat) continue;

                geometry.push([
                    lng,
                    lat,
                    // elevation in meters
                    data.records[i].enhanced_altitude || data.records[i].altitude || -1000,
                    getTimestamp(data.records[i].timestamp),
                ]);
            }

            const startTime = geometry[0][3]
                ? new Date(geometry[0][3] * 1000).toISOString()
                : new Date().toISOString();

            resolve([
                undefined,
                {
                    type: 'FeatureCollection',
                    features: [
                        {
                            type: 'Feature',
                            properties: {
                                title: data?.workout?.wkt_name || `Track ${startTime}`,
                                time_created: startTime,
                            },
                            geometry: {
                                type: 'LineString',
                                coordinates: geometry,
                            },
                        },
                    ],
                },
            ]);
        });
    });
}
